import { useState } from 'react';
import { ImageWithFallback } from './figma/ImageWithFallback';
import { Button } from './ui/button';
import { Badge } from './ui/badge';

export default function GalleryPage() {
  const [selectedCategory, setSelectedCategory] = useState('all');

  const images = [
    {
      id: 1,
      src: "https://images.unsplash.com/photo-1655432866668-fef51361d3d7?q=80&w=765&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      title: "Sugar Cane Fields in Mauritius",
      category: "farming",
      country: "Mauritius",
      description: "Lush sugar cane fields during the growing season"
    },
    {
      id: 2,
      src: "https://www.bma-worldwide.com/fileadmin/Templates/BMA/photos/header-images/BAG_Ausr%C3%BCstungen_Diffuseur_Header.jpg",
      title: "Modern Sugar Processing Facility",
      category: "processing",
      country: "South Africa",
      description: "State-of-the-art sugar mill with advanced technology"
    },
    {
      id: 3,
      src: "https://images.unsplash.com/photo-1559027615-cd4628902d4a?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      title: "Community Gathering",
      category: "community",
      country: "Fiji",
      description: "Local community celebrating harvest season"
    },
    {
      id: 4,
      src: "https://imbibemagazine.com/wp-content/uploads/2016/08/novo-fogo-feeding-press.jpg",
      title: "Traditional Sugar Making",
      category: "processing",
      country: "Belize",
      description: "Traditional methods of sugar production"
    },
    {
      id: 5,
      src: "https://images.unsplash.com/photo-1615811361523-6bd03d7748e7?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      title: "Sugar Crystal Formation",
      category: "product",
      country: "Eswatini",
      description: "Close-up of sugar crystals during processing"
    },
    {
      id: 6,
      src: "https://sandringhambulkfoods.co.nz/cdn/shop/files/F324AA1A-5053-43B6-BF98-6C385BEB693E.jpg?v=1716789535",
      title: "Raw Sugar Products",
      category: "product",
      country: "Zambia",
      description: "Various grades of raw sugar ready for export"
    },
    {
      id: 7,
      src: "https://images.unsplash.com/photo-1641347072423-7d8447466a1e?q=80&w=687&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      title: "Harvesting Season",
      category: "farming",
      country: "Mozambique",
      description: "Workers during the busy harvest period"
    },
    {
      id: 8,
      src: "https://images.unsplash.com/photo-1565870783541-ee598acdb28b?q=80&w=735&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      title: "Sustainable Farming Practices",
      category: "farming",
      country: "Tanzania",
      description: "Environmental conservation in sugar farming"
    },
    {
      id: 9,
      src: "https://assets.epicurious.com/photos/63e139132d16855fd03c2be3/master/pass/MakePowderedSugar_HERO_020223_46601.jpg",
      title: "Premium Sugar Varieties",
      category: "product",
      country: "Dominican Republic",
      description: "Specialty sugar products for premium markets"
    },
    {
      id: 10,
      src: "https://images.unsplash.com/photo-1545649309-d43113f1b401?q=80&w=687&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      title: "Worker Housing Development",
      category: "community",
      country: "Malawi",
      description: "Modern housing facilities for sugar industry workers"
    },
    {
      id: 11,
      src: "https://images.unsplash.com/photo-1599716471784-ac6ab30404af?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTB8fGNvbW11bml0eSUyMGhlYWx0aCUyMHdvcmtlcnxlbnwwfHwwfHx8MA%3D%3D",
      title: "Community Health Center",
      category: "community",
      country: "Zimbabwe",
      description: "Healthcare facility supported by sugar industry"
    },
    {
      id: 12,
      src: "https://images.unsplash.com/photo-1703194531119-e8b98a555cb6?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      title: "Export Terminal Operations",
      category: "processing",
      country: "Sudan",
      description: "Sugar loading operations at export terminal"
    }
  ];

  const categories = [
    { id: 'all', label: 'All Photos' },
    { id: 'farming', label: 'Farming & Agriculture' },
    { id: 'processing', label: 'Processing & Manufacturing' },
    { id: 'product', label: 'Products' },
    { id: 'community', label: 'Community' }
  ];

  const filteredImages = selectedCategory === 'all' 
    ? images 
    : images.filter(image => image.category === selectedCategory);

  const getCategoryColor = (category: string) => {
    const colors = {
      farming: 'bg-green-100 text-green-800',
      processing: 'bg-blue-100 text-blue-800',
      product: 'bg-amber-100 text-amber-800',
      community: 'bg-purple-100 text-purple-800'
    };
    return colors[category as keyof typeof colors] || 'bg-gray-100 text-gray-800';
  };

  return (
    <div className="min-h-screen py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-6">Photo Gallery</h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Explore the diverse world of sugar industries across ACP and LDC countries through 
            our comprehensive photo collection showcasing farming, processing, and community impact.
          </p>
        </div>

        {/* Category Filters */}
        <div className="flex flex-wrap gap-2 mb-8 justify-center">
          {categories.map((category) => (
            <Button
              key={category.id}
              variant={selectedCategory === category.id ? "default" : "outline"}
              onClick={() => setSelectedCategory(category.id)}
              className={selectedCategory === category.id ? "bg-amber-600 hover:bg-amber-700" : ""}
            >
              {category.label}
            </Button>
          ))}
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {filteredImages.map((image) => (
            <div key={image.id} className="group relative overflow-hidden rounded-lg shadow-md hover:shadow-xl transition-shadow">
              <ImageWithFallback
                src={image.src}
                alt={image.title}
                className="w-full h-64 object-cover group-hover:scale-105 transition-transform duration-300"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-0 left-0 right-0 p-4 text-white">
                  <h3 className="font-semibold mb-1">{image.title}</h3>
                  <p className="text-sm text-gray-200 mb-2">{image.description}</p>
                  <div className="flex items-center justify-between">
                    <span className="text-xs text-gray-300">{image.country}</span>
                    <Badge className={getCategoryColor(image.category)}>
                      {image.category}
                    </Badge>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Statistics */}
        <section className="mt-16 bg-gray-50 rounded-lg p-8">
          <h2 className="text-2xl font-bold text-gray-900 text-center mb-8">Our Visual Story</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
            <div>
              <div className="text-3xl font-bold text-amber-600 mb-2">500+</div>
              <div className="text-gray-600">Photos in Collection</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-amber-600 mb-2">16</div>
              <div className="text-gray-600">Countries Featured</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-amber-600 mb-2">50+</div>
              <div className="text-gray-600">Sugar Facilities</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-amber-600 mb-2">1000s</div>
              <div className="text-gray-600">People Showcased</div>
            </div>
          </div>
        </section>

        {/* Call to Action */}
        <section className="mt-12 text-center">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Share Your Story</h2>
          <p className="text-gray-600 mb-6 max-w-2xl mx-auto">
            Do you have photos from your sugar operations or community programs? We'd love to 
            feature them in our gallery to showcase the diverse impact of sugar industries across our member countries.
          </p>
          <Button className="bg-amber-600 hover:bg-amber-700">
            Submit Photos
          </Button>
        </section>
      </div>
    </div>
  );
}